package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val TealColorVariant = ColorVariant(
    n100 = Color(0xFFE7F9FF),
    n200 = Color(0xFFC6EDFB),
    n300 = Color(0xFF9DD9EE),
    n400 = Color(0xFF6CC3E0),
    n500 = Color(0xFF42B2D7),
    n600 = Color(0xFF2898BD),
    n700 = Color(0xFF227D9B),
    n800 = Color(0xFF206A83),
    n900 = Color(0xFF164555),
    n1000 = Color(0xFF1E3137)
)
